import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LockKeyhole } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function AdminLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/admin/login", { username, password });
      localStorage.setItem("kavlekar_admin_token", response.data.token);
      toast.success("Admin access granted");
      navigate("/admin");
    } catch {
      toast.error("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      className="flex min-h-screen items-center justify-center bg-gradient-to-b from-[#fffefb] to-[#f8f4ea] px-6"
      data-testid="admin-login-page"
    >
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md rounded-2xl border border-[#f2e6c9] bg-white p-8 shadow-[0_16px_40px_rgba(0,0,0,0.08)]"
        data-testid="admin-login-form"
      >
        <div className="inline-flex rounded-full bg-[#f9f4e8] p-3" data-testid="admin-login-icon-wrapper">
          <LockKeyhole className="h-5 w-5 text-[#b08d45]" />
        </div>
        <h1
          className="mt-4 font-[Playfair_Display] text-4xl text-[#1a1a1a]"
          data-testid="admin-login-title"
        >
          CMS Login
        </h1>
        <p
          className="mt-2 font-[Manrope] text-sm text-[#666666]"
          data-testid="admin-login-subtitle"
        >
          Manage blogs, case studies, and published papers.
        </p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="mb-1 block font-[Manrope] text-xs text-[#8b7a55]" data-testid="admin-login-username-label">
              Username
            </label>
            <Input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="Enter admin username"
              required
              data-testid="admin-login-username-input"
            />
          </div>
          <div>
            <label className="mb-1 block font-[Manrope] text-xs text-[#8b7a55]" data-testid="admin-login-password-label">
              Password
            </label>
            <Input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter admin password"
              required
              data-testid="admin-login-password-input"
            />
          </div>
        </div>

        <Button
          type="submit"
          className="mt-6 w-full rounded-full bg-[#c5a059] text-white hover:bg-[#b08d45]"
          disabled={loading}
          data-testid="admin-login-submit-button"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}
        </Button>
      </form>
    </main>
  );
}
